import Ajax from '@/api/ajax'

export const security = (data) => Ajax.request('/frameworks/systems/user/security', 'get', data, { showLoading: false })
// 登陆
export const verificationCode = (data) => Ajax.request('/frameworks/systems/user/send/verification/code', 'post', data, { showLoading: true })
export const uploadImage = (data) => Ajax.request('/portal/wx/file/upload', 'get', data, { showLoading: true })
export const userRegister = (data) => Ajax.request('/frameworks/systems/user/wechat/phone/bind', 'post', data, { showLoading: true })

// 用户
export const userCreate = (data) => Ajax.request('/user/info', 'post', data, { showLoading: true })
export const userUpdate = (data) => Ajax.request('/user/info', 'put', data, { showLoading: true })
export const userDetail = (data) => Ajax.request(`/business/user/uasUserDetail`, 'post', data, { showLoading: true })

export const userMemberDetail = (data) => Ajax.request(`/user/info/${data}`, 'get', '', { showLoading: true })

export const userDelete = (data) => Ajax.request(`/user/info/${data}`, 'delete', '', { showLoading: true })
export const userQuery = (data) => Ajax.request('/user/info/query', 'post', data, { showLoading: true })





